/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S6_HeadingInputs */

const tr_kvkkbasvuru_s6_heading = /** @type {(inputs: Kvkkbasvuru_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Red Sebepleri`)
};

const en_kvkkbasvuru_s6_heading = /** @type {(inputs: Kvkkbasvuru_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Grounds for Rejection`)
};

const de_kvkkbasvuru_s6_heading = /** @type {(inputs: Kvkkbasvuru_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Ablehnungsgründe`)
};

const ru_kvkkbasvuru_s6_heading = /** @type {(inputs: Kvkkbasvuru_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Основания для отказа`)
};

/**
* | output |
* | --- |
* | "6. Grounds for Rejection" |
*
* @param {Kvkkbasvuru_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s6_heading = /** @type {((inputs?: Kvkkbasvuru_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s6_heading(inputs)
	if (locale === "de") return de_kvkkbasvuru_s6_heading(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s6_heading(inputs)
	return tr_kvkkbasvuru_s6_heading(inputs)
});